/** Fixed piercing online-booking deposit (EUR). */
export const PIERCING_DEPOSIT_AMOUNT_EUR = 15;
/** Resolve the payable deposit from service deposit settings. */
export function calculateServiceDepositAmount(service) {
    if (!service?.depositRequired)
        return 0;
    const amount = service.depositAmount ?? 0;
    if (service.depositType === 'FIXED')
        return amount;
    if (service.depositType === 'PERCENTAGE') {
        const price = service.effectivePrice ?? service.basePrice ?? 0;
        return (price * amount) / 100;
    }
    return 0;
}
